























































import {fromEvent, interval, merge} from "rxjs"
import {map, debounce} from "rxjs/operators"
import StateComments from "@/components/StateComments.vue"
import tools from "@/tools.coffee"

export default {
    "name": "StateWaintingForInformation"
    "components": {StateComments}
    "props": {
        "context": {
            "type": Object
            "required": true
        }
        "human_created_on": String
        "email_set" : Array
    }
    "data": ()->
        return {
            "content": null
        }
    "methods":
        "update_data": (comments)->
            @content.data.comments = comments
            @$emit("state:update_data", @content.data)
        "delete_state": ()->
            @$emit("state:delete_state")
    # "updated": ()->
    #     @scroll_down()
    "computed":
        "hasSentEmail": ()-> 
            return @email_set.length > 0 && this.email_set.some((email) => email.sent_on != null && email.sent_on != '')
    "watch":
        "content.mhr_note": (new_value, old_value)->
            if new_value?
                if new_value != old_value
                    new_value = new_value.replace("\\n","\n")
    "mounted": ()->
        self = @
        mhr_note_stream = fromEvent(self.$refs.mhr_note, "input").pipe(
            debounce(() -> interval(500))
        ).subscribe(
            (event) ->
                # map((item) -> txt.replace(/(?:\r\n|\r|\n)/g, "\n"))
                data = tools.deep_copy(self.content.data)
                # data.mhr_note = data.mhr_note.replace(/(?:\r\n|\r|\n)/g, "\\n")
                self.$emit("state:update_data", data)
        )
    "created": ()->
        self = @

        @content = @context

        self.$djangows['onmodelsignals']({"modelName": "state", "appLabel": "state"}, (event)->
            if event.obj?
                # if event.obj.review == self.content.review.uid
                if event.obj.uid == self.content.uid
                    if event.signal_type == "post_save" and event.created == false
                        self.content.data.comments = event.obj.data.comments
                        # @$emit("state:update_data", @content.data)
        )

}
